module.exports = __webpack_public_path__ + "img/classic_rental20_4.54e85d43.jpg";